import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Menu } from 'lucide-react';
import MediaLibrary from '../components/MediaLibrary';
import AnalyticsDashboard from '../components/AnalyticsDashboard';
import NotificationBell from '../components/NotificationBell';
import {
  Sidebar,
  DashboardOverview,
  ConstitutionEditor,
  SignaturesManagement,
  ActivitiesManagement,
  AssociationsManagement,
  SiteSettingsManagement,
  SEOSettingsManagement,
  DataManagement,
  ProfileManagement,
} from './admin';

const AdminDashboard = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  
  return (
    <div className="min-h-screen bg-background">
      <Sidebar open={sidebarOpen} setOpen={setSidebarOpen} />
      
      <div className="lg:ml-64">
        <header className="sticky top-0 z-30 bg-background border-b px-4 py-3 flex items-center gap-4">
          <button 
            className="lg:hidden p-2 hover:bg-muted rounded-lg"
            onClick={() => setSidebarOpen(true)}
          >
            <Menu className="w-5 h-5" />
          </button>
          <h1 className="font-serif font-semibold">Admin Portal</h1>
          <div className="ml-auto">
            <NotificationBell />
          </div>
        </header>
        
        <main className="p-4 sm:p-6 lg:p-8">
          <Routes>
            <Route index element={<DashboardOverview />} />
            <Route path="analytics" element={<AnalyticsDashboard />} />
            <Route path="constitution" element={<ConstitutionEditor />} />
            <Route path="signatures" element={<SignaturesManagement />} />
            <Route path="activities" element={<ActivitiesManagement />} />
            <Route path="associations" element={<AssociationsManagement />} />
            <Route path="media" element={<MediaLibrary />} />
            <Route path="site-settings" element={<SiteSettingsManagement />} />
            <Route path="seo-settings" element={<SEOSettingsManagement />} />
            <Route path="data-management" element={<DataManagement />} />
            <Route path="profile" element={<ProfileManagement />} />
          </Routes>
        </main>
      </div>
    </div>
  );
};

export default AdminDashboard;
